import { Pricing } from './pricing/pricing';
import { Categories, StoreProduct, Currency, Frequency, ShoppingCartItemType } from '@vendasta/marketplace-packages';
import { AppPrice, AppPrices } from '@vendasta/marketplace-apps';
import { BillingPeriodInterface, RevenuePeriod } from '@vendasta/sales-orders';

export type CategoryToItemListMap = Map<string, StoreItem[]>;

export interface StoreItem {
  name: string;
  tagline: string;
  headerImageUrl: string;
  iconUrl: string;
  formattedPrice: string;
  purchased?: boolean;
  id?: string;
  pricing?: Pricing; // TODO: remove this once we replace all usages with AppPrice
  appPrice?: AppPrice;
  lmiCategories?: Categories[];
  type?: ShoppingCartItemType;
  parentName?: string;
  billingPeriod?: BillingPeriodInterface;
  revenuePeriod?: RevenuePeriod;
}

export function convertStoreProductToStoreItemWithAppPrice(sp: StoreProduct, appPrices: AppPrices): StoreItem {
  const storeItem: StoreItem = {
    id: sp.appId || sp.packageId,
    name: sp.name,
    tagline: sp.tagline,
    iconUrl: sp.iconUrl,
    headerImageUrl: sp.headerImageUrl,
    formattedPrice: null,
    type: sp.appId
      ? ShoppingCartItemType.SHOPPING_CART_ITEM_TYPE_PRODUCT
      : ShoppingCartItemType.SHOPPING_CART_ITEM_TYPE_PACKAGE,
    lmiCategories: sp.lmiCategories,
    appPrice: appPrices?.pricesForContexts['retail'],
  };
  return storeItem;
}

// TODO: remove this after updating all usages to call convertStoreProductToStoreItemWithAppPrice
export function convertStoreProductToStoreItem(sp: StoreProduct): StoreItem {
  const storeItem: StoreItem = {
    id: sp.appId || sp.packageId,
    name: sp.name,
    tagline: sp.tagline,
    iconUrl: sp.iconUrl,
    headerImageUrl: sp.headerImageUrl,
    formattedPrice: null,
    type: sp.appId
      ? ShoppingCartItemType.SHOPPING_CART_ITEM_TYPE_PRODUCT
      : ShoppingCartItemType.SHOPPING_CART_ITEM_TYPE_PACKAGE,
    lmiCategories: sp.lmiCategories,
  };
  const pricing = sp.pricing;
  if (pricing) {
    storeItem.pricing = {
      currency: pricing.currency ? Currency[pricing.currency] : 'USD',
      prices: (pricing.prices || []).map((p) => {
        return {
          price: p.price,
          isStartingPrice: p.isStartingPrice,
          frequency: Frequency[+p.frequency] || 'Monthly',
        };
      }),
    };
  }
  return storeItem;
}

export enum HeaderActionType {
  BUY_IT_NOW = 1,
  ADD_TO_CART = 2,
  NONE = 3,
}
